import type { ReactNode } from 'react'

import { Forbidden } from '@/components/feedback/Forbidden'
import { useAuthStore } from '@/stores/auth-store'

interface RequirePermissionProps {
  /** Dizi: izinlerden biri yeter. */
  permission: string | readonly string[]
  children: ReactNode
}

/**
 * Yalnızca **görsel** kapı (AGENTS.md §4): karar her zaman backend'de. Yetkisiz sayfa
 * menüde zaten görünmez (bkz. `app/layout/AppSidebar.tsx`); buraya doğrudan URL ile
 * girildiğinde 403 ekranı gösterir.
 */
export function RequirePermission({ permission, children }: RequirePermissionProps) {
  const allowed = useAuthStore((state) =>
    (typeof permission === 'string' ? [permission] : permission).some((key) =>
      state.hasPermission(key),
    ),
  )
  if (!allowed) return <Forbidden />
  return <>{children}</>
}
